<header>
    <app-header></app-header>
  </header> 

  <div class="outer-conatiner">
    <div class="inner-container">  
      <div class="code-enf-wrapper">
        <!-- <button mat-button   class="button-primary enf-btn"   type="submit" color="vov-ui-primary" (click)="gotoAddress()">Search Address</button> -->
        <button mat-button   class="button-primary enf-btn"   type="submit" color="vov-ui-primary" (click)="gotoCreateCase()">Create Case</button>
        <button mat-button   class="button-primary enf-btn"   type="submit" color="vov-ui-primary" (click)="gotoCaseList()">Case Details</button>
        <button mat-button   class="button-primary enf-btn"   type="submit" color="vov-ui-primary" (click)="gotoExpiredCase()">Case History</button>
      </div>
    </div>
</div>